module.exports = "/_next/static/images/Hero-md-5657190eb041fffe74f60a635a58eebf.png";